module.exports = __webpack_public_path__ + "static/media/  (26).67e537d7.jpg";